// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"82":"26a54730","314":"a8284333"}[chunkId] + ".css";
};